<template>

    <div class="circle-btn" @click="context_menu_show = !context_menu_show">
        <span class="material-symbols-outlined">language</span>

        <span class="circle-btn--animation"></span>

        <ContextMenu :show="context_menu_show">
            <template #default>
                <ul class="menu">
                    <li class="menu__item" :class="{'menu__item--active': lang === 'pl'}">
                        <div @click="setLangToStorage('pl')">
                            <span>{{ t("polish") }}</span>
                        </div>
                    </li>
                    <li class="menu__item" :class="{'menu__item--active': lang === 'cz'}">
                        <div @click="setLangToStorage('cz')">
                            <span>{{ t("czech") }}</span>
                        </div>
                    </li>
                    <li class="menu__item" :class="{'menu__item--active': lang === 'en'}">
                        <div @click="setLangToStorage('en')">
                            <span>{{ t("english") }}</span>
                        </div>
                    </li>
                    <li class="menu__item" :class="{'menu__item--active': lang === 'de'}">
                        <div @click="setLangToStorage('de')">
                            <span>{{ t("germany") }}</span>
                        </div>
                    </li>
                </ul>
            </template>
        </ContextMenu>
    </div>

</template>

<script>
import ContextMenu from "@/views/Components/ContextMenu.vue";
import {mapState, mapActions} from "vuex";
import View from "@/views/View.vue"

export default {
    name: "Lang",
    components: {
        ContextMenu,
    },
    extends: View,
    data: () => ({
        context_menu_show: false,
    }),
    methods: {
        /**
         * Dołączanie metod z VUEX'a
         */
        ...mapActions({
            setLangToStorage: "app/setLangToStorage"
        })
    },
    computed: {
        /**
         * Dołączanie zmiennych z VUEX'a
         */
        ...mapState({
            lang: state => state.app.lang
        })
    }
}
</script>

<style scoped lang="scss">

.circle-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 0.625rem;
  border: 1px solid #646464;
  color: #646464;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.5s ease 0s;
  cursor: pointer;
  user-select: none;

  &:hover {
    border-color: rgb(73, 78, 155);

    & .material-symbols-outlined {
      color: #fff;
    }

    & > .circle-btn--animation {
      opacity: 1;
      visibility: visible;
      transform: scale(1);
    }
  }

  & .material-symbols-outlined {
    transition: all 0.5s ease 0s;
    z-index: 1;
    font-size: 1.25rem;
  }

  &--animation {
    position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    top: -1px;
    left: -1px;
    background-color: rgb(73, 78, 155);
    transition: all 0.5s ease 0s;
    opacity: 0;
    transform: scale(0.2);
    visibility: hidden;
  }
}

.menu {
  list-style: none;
  display: block;
  padding: 10px 0;
  background-color: #fff;
  transition: all 0.25s ease 0s;

  &__item {
    position: relative;
    margin: 5px 0;

    & > div {
      display: block;
      padding: 2px 20px;
      line-height: 26.25px;
      cursor: pointer;
      transition: all 0.25s ease 0s;

      & > span {
        font-size: 0.9375rem;
        transition: all 0.25s ease 0s;
      }

      &::before {
        top: 50%;
        content: '';
        position: absolute;
        left: 20px;
        width: 0;
        height: 2px;
        border-radius: 1px;
        background: rgb(73, 78, 155);
        transition: all 0.25s ease 0s;
      }

      &:hover {
        padding-left: 35px;

        &::before {
          width: 7px;
        }

        & > span {
          color: rgb(73, 78, 155);
        }
      }
    }

    &--active {

      & > div {
        padding-left: 35px;

        &::before {
          width: 7px;
        }

        & > span {
          color: rgb(73, 78, 155);
        }
      }
    }
  }
}

html.contrast {

  & .circle-btn {
    border-color: #000;
    color: #000;

    &:hover {
      border-color: yellow;

      & .material-symbols-outlined {
        color: #000;
      }
    }

    &--animation {
      background-color: yellow;
    }
  }

  & .menu {
    background-color: gold;

    & > .menu__item {

      &:hover {

        & > div {

          & > span {
            color: #000;
          }

          &::before {
            background: #000;
          }
        }
      }

      &--active {

        & > div {
          padding-left: 35px;

          & > span {
            color: #000;
          }

          &::before {
            background: #000;
          }
        }
      }
    }
  }
}

</style>